// extracted by mini-css-extract-plugin
module.exports = {"emailField":"cdv60","radioBtnLabel":"fguIh","radioBtnGroup":"g2vom","itemIdentifierLabel":"krQas"};